<template>
  <CBox bg="#fff" borderRadius="16px" p="24px" :minWidth="['auto', '400px']"
minHeight="460px">
    <OmtTypography v-if="currentRoute !== 'network.plan'" as="p2" color="#4A5E77" mb="24px">
      <span v-for="(route, idx) in lastRoute" :key="route.name">
        <router-link :to="{ name: route.name }" style="color: #68788c; text-decoration: none">
          {{ route.label }}
        </router-link>
        <span v-if="idx < lastRoute.length - 1"> &gt; </span>
      </span>
      <span v-if="routeName">
        &gt; <omt-bold class="current-route">{{ routeName }}</omt-bold>
      </span>
    </OmtTypography>
    <router-view />
    <template v-if="$route.name === 'network.accredited'">
      <AccreditedList />
    </template>
  </CBox>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "IframeAffiliateSearch",
  components: {
    AccreditedList: () => import("./accredited-list.vue")
  },
  computed: {
    ...mapState("openNetworkSearch", ["selectedPlanCategory", "selectedPlanName"]),
    currentRoute() {
      return this.$route.name;
    },
    routeName() {
      const name = this.$route.name;
      switch (name) {
        case "network.plan":
          return "Planos";
        case "network.search":
          return "Tipo de estabelecimento";
        case "network.specialities":
          return "Especialidade";
        case "network.location":
          return "Localização";
        case "network.accredited.list":
          return "Credenciados";
        case "network.doctor.detail":
          return "Detalhes";
        case "network.plans.served":
          return "Planos atendidos";
        default:
          return "";
      }
    },
    lastRoute() {
      const routes = [
        { name: "network.plan", label: "Planos" },
        { name: "network.search", label: "Tipo de estabelecimento" },
        { name: "network.specialities", label: "Especialidade" },
        { name: "network.location", label: "Localização" },
        { name: "network.accredited.list", label: "Credenciados" },
        { name: "network.doctor.detail", label: "Detalhes do credenciado" },
        { name: "network.plans.served", label: "Planos atendidos" }
      ];
      const currentIdx = routes.findIndex(r => r.name === this.$route.name);
      if (currentIdx <= 0) return [];
      return routes.slice(0, currentIdx);
    }
  },
  mounted() {
    if (!this.selectedPlanName && this.currentRoute !== "network.plan") {
      this.$router.push({ name: "network.plan" });
    }
  }
};
</script>

<style scoped>
.current-route {
  color: #68788c;
}
</style>
